var map = {
	"./Ellipse 108.svg": 3313,
	"./Ellipse 109.svg": 880,
	"./Ellipse 110.svg": 9097,
	"./Ellipse 111.svg": 6577,
	"./Ellipse 112.svg": 2750,
	"./IconGroup.svg": 3759,
	"./IconGroup2.svg": 7321,
	"./IconGroup3.svg": 6387,
	"./IcongroupFinal.svg": 2528,
	"./ModuleIcon.svg": 9598,
	"./ModuleIcon0.svg": 650,
	"./ModuleIcon2.svg": 9601,
	"./ModuleIcon3.svg": 9218,
	"./ModuleIcon4.svg": 7133,
	"./Polygon 1.svg": 249,
	"./PurpleCircle.svg": 5801,
	"./books.gif": 7114,
	"./chevron-down-gray.svg": 1651,
	"./chevron-down.svg": 1959,
	"./chevron-left.svg": 2840,
	"./chevron-right-purple.svg": 150,
	"./chevron-right.svg": 8266,
	"./chevron-up-gray.svg": 810,
	"./demo.svg": 2640,
	"./demov2.png": 7433,
	"./expand_less.svg": 3633,
	"./expand_more.svg": 3378,
	"./media1.svg": 8142,
	"./media2.svg": 4866,
	"./plus.svg": 6182,
	"./refresh.svg": 7279,
	"./right-arrow.svg": 3964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2096;